<template>
	<div class="MyTabs-pane">
	
	  <div class="my-title1">
			<div class="L"><h2><a href="">中经专题</a></h2></div>
			<div class="R"><btn class="cei-icon icon-edit icon-edit-sty1" @click="guanlishow=true">编辑</btn></div>
		</div>
		<ul class="list2">
			<li v-for="(item,index) in zhuantiList">
				<p><a href="javascript:;">{{item.columnname}}</a></p>
				<p class="R" v-show="dingyueList[index].length"><span class="num">{{dingyueList[index].length}}</span></p>
			</li>
			<!-- <li><p><a href="">形势分析</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">政策讨论</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">运营数据</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">长三角</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">长三角</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">北交所</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">健康医疗</a></p><p class="R"><span class="num">5</span></p></li> -->
		</ul>
		<!-- <div class="my-title1">
			<div class="L"><h2><a href="">中经简报</a></h2></div>
			<div class="R"><btn class="cei-icon icon-edit icon-edit-sty1">编辑</btn></div>
		</div>
		<ul class="list2">
			<li><p><a href="">经济动态</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">形势分析</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">政策讨论</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">运营数据</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">长三角</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">长三角</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">北交所</a></p><p class="R"><span class="num">5</span></p></li>
			<li><p><a href="">健康医疗</a></p><p class="R"><span class="num">5</span></p></li>
		</ul> -->
		<div id="SubscribeManage_pop" v-show="guanlishow"><!-- trial_apply -->
			<div class="pop_right"><!-- pop_right -->
				<ul class="pop_right_header2">
					<li><h2>专题订阅管理</h2></li>
					<li><btn class="pop_right_close2" name="pop-close" @click="cancelGuanliPanel"></btn></li>
				</ul>
				<div class="pop_right_main"><!-- main -->
			
						<h3>专题</h3>
						<ul class="group3b">
							<li v-for="(item,index) in zhuantiList" class="group3b_item">
								<div @click="showSelectPanel(item.columnid,$event)" @blur="hideSelectPanel" tabindex="99" class=" cei-select select_sty1" name="cei-select" style="width:100%">
									<i class="cei-icon icon-arrdown" :class="{'icon-arrow-on':selectedactive==item.columnid}"></i>
									<div class="inpout" >
										<dot></dot>
										<name :class="{'red':selectedactive==item.columnid}" >{{item.columnname}}</name>
										<numbers v-show="dingyueList[index].length">+{{dingyueList[index].length}}</numbers>
									</div>
									<figure v-show="selectedactive==item.columnid" class="MyTabs Mulchoice_list_out"><!-- MyTabs -->
									  	<el-checkbox-group v-model="dingyueList[index]">
									  		<el-checkbox v-for="(subitem,subindex) in item.Child" :label="subitem.columnid">{{subitem.columnname}}</el-checkbox>
									  	</el-checkbox-group>
									</figure><!-- /MyTabs -->	
								</div>
							</li>
						</ul>
						
				</div><!-- /main -->
				<div class="pop_right_footer2">
						<btn class="s_btn" @click="saveUserOrders"  >确定</btn>
				</div>
			</div><!-- /pop_right -->
			<div class="pop_bg"></div>
		</div><!-- /trial_apply -->
	</div>
</template>

<script>
	export default{
		data() {
			return {
				loadingMask:false,
				guanlishow: false,
				dingyueList:[],
				origindingyueList:[],
				origindingyuecount:0,
				zhuantiList:[],
				selectedactive:'',
			}
		},
		mounted:function(){
			this.getAllUserOrder();
			
		},
		methods:{
			hideSelectPanel:function(evnet){
				this.selectedactive='';
				// console.log('blur'+this.selectedactive);
			},
			showSelectPanel:function(id,event){
				// console.log(event.target.tagName+' '+event.target.className);
				// if(event.target.tagName!='DIV'&&event.target.tagName!='NAME'&&event.target.tagName!='NUMBERS'&&event.target.tagName!='I'){
				// 	// event.preventDefault();
				// 	return false;
				// }
				// if(event.target.className.indexOf('el-checkbox')>-1){
				// 	return false;
				// }
				if(this.selectedactive==id){
					if(event.target.tagName=='FIGURE'||event.target.className=='el-checkbox-group'){
						return false;
					}
					// if(event.target.tagName=='NAME'||event.target.tagName=='NUMBERS'||event.target.tagName=='I'){
					// 	this.selectedactive='';
					// }
					this.selectedactive='';
				}
				else{
					this.selectedactive=id;
				}
				// console.log(this.selectedactive);
			},
			// getAllOrderCol:function(){
			// 	let _this = this;
			// 	_this.loadingMask = true;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'UserInfo/selectAllOrderCol',
			// 			responseType: 'json',
			// 			params: {
							
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.zhuantiList = response.data.data.data;
			// 			_this.loadingMask = false;
			// 		})
			// 		.catch(function(error) {
			// 			_this.loadingMask = false;
			// 			console.log(error);
			// 		});
			// },
			getAllUserOrder:function(){
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/selectAllUserOrder',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						var dingyuedata=response.data.data.data;
						_this.origindingyueList=[];
						_this.origindingyuecount=0;
						for(var i=0;i<dingyuedata.length;i++){
							_this.origindingyueList.push([]);
							for(var j=0;j<dingyuedata[i].Child.length;j++){
								if(dingyuedata[i].Child[j].ordertype=="1"){
									_this.origindingyueList[i].push(dingyuedata[i].Child[j].columnid);
									_this.origindingyuecount++;
								}
							}
						}
						_this.dingyueList = JSON.parse(JSON.stringify(_this.origindingyueList));
						_this.zhuantiList = dingyuedata;
						_this.loadingMask = false;
						_this.$emit('senddata',_this.origindingyuecount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			saveUserOrders:function(){
				var colidstring='';
				for(var i=0;i<this.dingyueList.length;i++){
					if(this.dingyueList[i].length>0){
						if(colidstring){
							colidstring+=',';
						}
						colidstring+=this.dingyueList[i].join(',');
					}
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/SaveUserOrders',
						responseType: 'json',
						params: {
							ColID:colidstring
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$message({
								message: '订阅修改成功',
								type: 'success'
							});
							_this.guanlishow=false;
							_this.getAllUserOrder();
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			cancelGuanliPanel:function(){
				this.guanlishow=false;
				this.dingyueList = JSON.parse(JSON.stringify(this.origindingyueList));
				// for(var i=0;i<this.origindingyueList.length;i++){
				// 	this.$set(this.dingyueList[i],'selected',this.origindingyueList[i].selected);
				// }
				// console.log(this.dingyueList);
			}
		}
	}
</script>

<style>
</style>
